<template>
    <div class="AIAnswer">
        <!-- 文件临时存放区域 -->
        <div class="file-range" v-if="updateLoading">
            <file-upload :file="file" :file-loading="fileLoading" :update-loading="updateLoading"
                :update-error="updateError" @delete-file="deleteFile" />

        </div>
        <el-input type="textarea" :autosize="{ minRows, maxRows }" :maxlength="20000" :placeholder="placeholder"
            v-model="textarea" @keydown.native.enter="inputKeySend">
        </el-input>
        <div class="tools">
            <div class="send">
                <el-tooltip placement="top">
                    <div slot="content" class="curContent">
                        <p>上传附件（仅识别文字）</p>
                        <p>文件类型：{{ fileFormat.join(' , ') }}</p>
                        <p>文件大小：32k</p>
                    </div>
                    <p class="cursor_1 uRound t-m-r-10" @click.stop="openFile">
                        <svg-icon iconClass="updateFile1" class="update"></svg-icon>
                    </p>
                </el-tooltip>
                <el-tooltip :disabled="textarea.trim() ? true : false" placement="top">
                    <div slot="content" class="curContent1">
                        <p>请输入问题</p>
                    </div>
                    <!-- (!textarea.trim() && (!file || updateError)) -->
                    <p class="unsending round cursor_1" v-if="!textarea.trim() && !status"><img
                            src="@/assets/image/ai_wenda/send.png" width="22" height="22" style="padding-right: 5px;" />
                    </p>
                </el-tooltip>
                <!-- (textarea.trim() ||  file  && !updateError) -->
                <p class="sending round cursor_1" v-if="textarea.trim() && !status" @click.stop="send"><img
                        src="@/assets/image/ai_wenda/send.png" width="22" height="22" style="padding-right: 5px;" /></p>
                <el-tooltip content="停止生成" placement="top">
                    <p class="stoping round cursor_1" v-if="status" @click.stop="stop"><img
                            src="@/assets/image/ai_wenda/icon5.png" width="12" height="12" /></p>
                </el-tooltip>

            </div>
        </div>
        <input type="file" ref="fileInput" :accept="accept.join(',')" class="file-input" @change="handleFileChange">
        <login />
    </div>
</template>
<script>
import { EventBus } from '@/utils/eventBus'
import AnApi from '@/api/answer.js'
import validateUploadedFile from '@/utils/fileValidator'
import FileUpload from '@/components/dongeb/‌FileUpload.vue'
import { update } from 'lodash'
import Login from '@/components/login.vue'
export default {
    components: {
        FileUpload,Login
    },
    props: {
        placeholder: {
            type: String,
            default: '全民作家大模型升级!支持更长上下文加持，理解能力再突破 -- 轻松帮你搭大纲、做设定创作灵感不设限，请从对话开始吧~'
        },
        minRows: {
            type: Number,
            default: 2
        },
        maxRows: {
            type: Number,
            default: 8
        },
        status: {
            type: Boolean
        },
    },
    mounted() {
        this.getUserLoginState(false)
        EventBus.$on('curTask', (item) => {
            // console.log('执行的对话任务监听，目的是将产生的任务id和索引记录下来，只要是有新的对话任务都会进入这里=', item)
            this.curTask = { ...item }
        })
    },
    beforeDestroy() {
        EventBus.$off('curTask')
    },
    data() {
        return {
            textarea: '',
            fileFormat: ['TXT', 'Word'],
            accept: [
                'text/plain',
                'application/msword',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            ],
            file: null,//上传文件
            updateSize: 32768,//32k
            fileLoading: false,//文件上传状态
            updateError: '',
            fileId: '',
            updateLoading: false,
            curTask: {
                curId: '',
                curIndex: '',
            },

        }
    },
    methods: {
        //发送
        send() {
            if (this.showLoginPage()) return
            let data = {}
            console.log((!this.file && this.updateError))
            if(!this.textarea.trim()){
                this.$message.warning('请输入问题内容')
                return
            }
            console.log('可以发送了')
            if (this.file && !this.updateError) {
                data.file = this.file;
                data.fileId = this.fileId
            }
            data.text = this.textarea.trim()
            EventBus.$emit('send', data)
            this.textarea = ''
            this.deleteFile()
        },
        //停止
        stop() {
            EventBus.$emit('stop', this.curTask)
        },
        //输入框按键发送事件
        inputKeySend(e) {
            if (this.showLoginPage()) return
            if (!e.shiftKey) { // 如果同时按 Shift+Enter，允许换行
                e.preventDefault()
                if (this.textarea.trim() &&!this.status) {
                    this.send()
                }
            }

        },
        //唤起文件弹窗
        openFile() {
            if (this.showLoginPage()) return
            this.$refs.fileInput.click()
        },
        //选择文件
        async handleFileChange(e) {
            const files = e.target.files
            if (files.length === 0) return
            console.log(this.file)
            try {
                this.file = {
                    filename: files[0].name,
                    size: files[0].size,
                }
                const result = await validateUploadedFile(files[0], this.accept, this.fileFormat, this.updateSize, '32k');
                console.log('文件验证通过：', result);
                //执行上传
                this.updateFiles(result.file)
            } catch (error) {
                this.$message.error(error.message)
                this.file = null
                this.$refs.fileInput.value = ''
            }
        },
        //执行上传
        updateFiles(file) {
            this.updateLoading = true
            this.fileLoading = false
            AnApi.updateFiles({ file }).then(res => {
                this.fileLoading = true
                if (res.code == 200) {
                    this.updateError = ''
                    this.fileId = res.data
                } else {
                    this.updateError = res.msg
                }
            }).catch((e) => {
                this.fileLoading = true
                this.updateError = '系统出错'
                this.$message.error(e)
            })
        },
        deleteFile() {
            this.updateLoading = false
            this.fileLoading = false
            this.file = null
            this.updateError = ''
            this.fileId = ''
            this.$refs.fileInput.value = ''
        }
    }
}
</script>
<style lang="scss" scoped>
.AIAnswer {
    width: 100%;
    background: #FFFFFF;
    box-shadow: 0px 0px 16px 0px #F1F4FF;
    border-radius: 10px;
    border: 1px solid var(--tech-primary);
    padding: 20px 30px 0px;
    position: relative;

    ::v-deep(.el-textarea__inner) {
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 16px;
        color: #666666 !important;
        border: none;
        resize: none;
        @include scrollbar();

        &:hover {
            @include scrollbar_hover();
        }

        &::placeholder {}
    }

    .file-range {
        padding: 0 0 14px;

        .fileRom {
            background-color: var(--tech-btn-gray);
            border-radius: 12px;
            width: calc(33.3333% - 8.33333px);
            min-width: 200px;
            transition: background-color .3s;
            position: relative;
            transition: box-shadow .2s ease-in-out;


        }

        .loadingOk {
            &:hover {
                cursor: pointer;
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);

                .file_del {
                    opacity: 1;
                }

            }
        }

        .fileItem {
            align-items: center;
            padding: 8px;
            display: flex;
            position: relative;

            .file_icon {
                display: flex;
                align-items: center;
                font-size: 32px;
                width: 32px;
                height: 32px;
                flex-shrink: 0;
            }

            .file_content {
                min-width: 0;

                .file_name {
                    color: #262626;
                    min-height: 20px;
                    margin: 0;
                    font-size: 14px;
                    font-weight: 500;
                    line-height: 20px;
                    flex: 1;
                }

                .file_size {
                    font-size: 12px;
                    color: var(--tech-text-muted);

                    .error {
                        color: #e53535;
                        display: block;
                    }
                }
            }

            .file_del {
                z-index: 1;
                opacity: 0;
                will-change: opacity;
                cursor: pointer;
                box-sizing: border-box;
                background-color: #fff;
                border-radius: 50%;
                justify-content: center;
                align-items: center;
                width: 20px;
                height: 20px;
                transition: opacity .2s ease-in-out;
                display: flex;
                position: absolute;
                top: -5px;
                right: -5px;
                box-shadow: 0 1px 2px rgba(148, 147, 147, .25), inset 0 0 0 .5px #ededed;
            }

            .errorText {
                background-color: #e53535;
                box-shadow: 0 1px 2px rgba(148, 147, 147, .25);

                svg {
                    color: #fff;
                }
            }
        }
    }

    .tools {
        .send {
            display: flex;
            align-items: center;
            justify-content: flex-end;

            p {
                width: 45px;
                height: 45px;
                position: relative;
                display: flex;
                align-items: center;
                justify-content: center;
                transition: all 0.3s;
            }

            .uRound {
                &:hover {
                    background: var(--tech-table-bg);
                    border-radius: 50%;
                }
            }

            .round {
                background: var(--tech-table-bg);
                border-radius: 50%;
            }

            .unsending {
                filter: grayscale(100%);
                -webkit-filter: grayscale(100%);
                /* Safari 兼容 */
                cursor: not-allowed;
            }
        }
    }
}

.curContent,
.curContent1 {
    p {
        margin: 0;
        padding: 3px 0;
    }
}

.curContent {
    min-width: 150px;
}

.curContent1 {
    min-width: 60px;
}

.update {
    color: #333;
    font-size: 28px;
}

.file {
    font-size: 25px;
}

.loadingSvg {
    color: #636E72;
    font-size: 25px;
}

.del {
    font-size: 60%;
    color: #636E72;
}

.file-input {
    display: none;
}
</style>